import {CSSProperties, memo, useMemo} from "react";
import {CELL_SIZE} from "../../utility/types";
import {Vec2} from "../../utility/math/vec2";

export const ConnectionAnchor = memo(({position}: {position: Vec2}) => {
  // Convert grid position to pixel coordinates
  const pixelPosition = useMemo(() => {
    return position.mulScalar(CELL_SIZE).addScalar(0.5 * CELL_SIZE);
  }, [position]);

  const svgStyle = useMemo<CSSProperties>(() => ({position: "absolute", top: 0, left: 0, overflow: "visible"}), []);

  return (
    <svg style={svgStyle}>
      <circle cx={pixelPosition.x} cy={pixelPosition.y} r="5" fill="white" stroke="black" strokeWidth="1.5" />
    </svg>
  );
});
